import * as React from "react";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { PensionType } from "../../../../../../Wrap/Constants/Enums/Domain/PensionType";
import { IStepConfig, StepType } from "../../../../../Shared/Process/Process/Process";
import { Navigator } from "../../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Contents } from "../../../../Resoures/Contents";
import { Urls } from "../../../../Urls";
import { NewBusinessAction } from "../Actions/NewBusinessAction";
import { NBSteppers } from "../Resource/Contents";
import { NewBusinessStore } from "../Stores/Variable";
import { AdviserCharges } from "./SIPP/AdviserCharges/AdviserCharges";
import { InvestmentSelectionTool } from "./SIPP/IST/IST";
import { PaymentsIn } from "./SIPP/PaymentsIn/PaymentsIn";
import { PaymentsIn as PaymentsInISA } from "./ISA/PaymentsIn/PaymentsIn";
import { AdviserCharges as AdviserChargesISA } from "./ISA/AdviserCharges/AdviserCharges";
import { InvestmentSelectionTool as InvestmentSelectionToolISA } from "./ISA/IST/InvestmentSelectionTool";
import { PaymentsIn as PaymentsInPP } from "./PersonalPortfolio/PaymentsIn/PaymentsIn";
import { AdviserCharges as AdviserChargesPP } from "./PersonalPortfolio/AdviserCharges/AdviserCharges";
import { InvestmentSelectionTool as InvestmentSelectionToolPP } from "./PersonalPortfolio/IST/InvestmentSelectionTool";
import { IncomePaymentDetails } from "./SIPP/IncomePaymentDetails/IncomePaymentDetails";
import { WrapperSelection } from "./WrapperSelection/WrapperSelection";
import { WrapCashPaymentsIn } from "./WrapCash/WrapCashPaymentsIn";
import { Review } from "./Review/Review";
import { WizardComponent } from "../../../../../Shared/Process/WizardComponent";
import { DocumentsAndDeclarations } from "../../Common/Documents/Components/DocumentsAndDeclarations";
import { Confirmation } from "../../../../../Shared/Process/Process/Confirmation";
import {
    hasCashTransfer,
    hasRegularPayments,
    hasSinglePayments,
} from "../../../../../Shared/IST/Components/Shared/Utils";
import { FullClientDetail } from "./FullClientDetail/FullClientDetail";
import { Withdrawals } from "../../Common/Withdrawals/Withdrawals";
import { ProcessType } from "../../../../../Shared/IST/Resource/Content";
import { ApplyModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { Lightbox } from "../../../../../../react-core/Html/Components/Lightbox";
import { SubAccountTypeHelper } from "../../Common/Helpers/SubAccountTypeHelper";
import { processTypeEnum } from "../../Common/Resource/Contents";
import { InstructionStatus } from "../../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { DrawdownDetails } from "./SIPP/DrawdownDetails/DrawdownDetails";
import { QuoteInstructionStore } from "../../NewQuoteWizard/Store/Variable";
import { NewQuoteAction } from "../../NewQuoteWizard/Actions/NewQuoteAction";
import { showIncome } from "../../Common/PaymentsIn/SIPP/ValidationHelper";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { Action } from "../../../../Actions/Action";
import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { DrawdownCalculationStoreStore } from "../../Common/SIPP/DrawdownDetails/Store/Variable";
import { Methods } from "../../../../Common/CommonHelper";
import { Transition } from "../../../../../Shared/Process/Process/Transition";
import { AccountAdviceType } from "../../../../../../Wrap/Constants/Enums/Apply/AccountAdviceType";
import { ClientAccount } from "../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { RestrictionStore } from "../../Common/Restrictions/Variable";
import { ProcessType as ActivityType } from "../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { InstructionDocumentTypeRequestTriggerActionsCreator } from "../../Documents/Actions/InstructionDocumentTypeRequestTriggerActionsCreator";
import { subAccountTypeMap } from "../../PortfolioDashboard/Components/Performance/Resource/Contents";
import { TransitionalConfirmation } from "../../../../../Shared/Process/Process/TransitionalConfirmation";
import { StaticUrls } from "../../../../Resoures/StaticUrls";
import { HierarchyIdHelper } from "../../../../../Shared/Common/HierarchyIdHelper";
import { HierarchyLevelName } from "../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { InvestorType } from "../../../../../../Wrap/Models/Domains/Account/SlAccounts/InvestorType";
import { ClientNameHelper } from "../../Common/Helpers/ClientNameHelper";
import { ChargesHelper } from "../../Common/Helpers/ChargesHelper";
import { ClientAccountStore, TreasuredAssetsStore } from "../../../../Stroes/Variable";
import { PortfolioDashboardAction } from "../../PortfolioDashboard/Action/PortfolioDashboardAction";
import { PortfolioDashboardMultiSelectionStore } from "../../PortfolioDashboard/Store/Variable";
import { ServiceProposition } from "../../../../../../Wrap/Constants/Enums/ServiceProposition";
import { LegacyProductPaymentsIn } from "./LegacyProduct/PaymentsIn";
import { AccountRoleInstructionNbecWizardSessionMappingModel } from "../../../../../../Wrap/Models/Models/Instructions/AccountRoleInstructionNbecWizardSessionMappingModel";
import { isJointOrTrustAccount } from "./WrapperSelection/WrapperSelctionHelper";

export class NewBusinessWizard extends WizardComponent {
    constructor(props: any) {
        super(props);
        this.subscribeToStore(NewBusinessStore, () => this.onNBInstructionStoreChange());
        this.subscribeToStore(DrawdownCalculationStoreStore, () => this.onPostDrawdown());
    }

    private onNBInstructionStoreChange() {
        const data = NewBusinessStore.getData();
        data.ClAccountId = data.ShellHeadClAccountId ?? this.state.clientAccount?.HeadClAccountId;
        this.setState({
            isLoading: false,
            data: data,
            onPosting: false,
            active: data?.Status === InstructionStatus.Pending || data?.Status === InstructionStatus.NotSpecified,
        });
    }

    private onPostDrawdown() {
        if (DrawdownCalculationStoreStore.getActionType() == ActionType.Loading) {
            this.setState({ onPosting: true });
        }
    }

    componentDidMount() {
        super.componentDidMount();
        const hierarchyId = getQueryParameters()["hierarchyid"];
        this.setState({
            data: {
                SelectedProducts: [{ SubAccountType: SubAccountType.WrapCash, IsIncomePaymentDetailsSelected: false }],
                AllBankAccounts: [],
                BankAccountInstructions: [],
                GiaModel: {},
                PensionApply: {},
                IsaModel: {},
                QuoteReference: {},
                AnnuityAssumptions: { PensionIncreases: 0 },
                ExistingAccountHierarchyId: hierarchyId,
                ActivityType: CommonHelper.isNullOrEmpty(hierarchyId)
                    ? ActivityType.NewBusiness
                    : ActivityType.NewBusinessExistingClient,
                ClAccountId: null,
                IsJointAccount: false,
            },
        });
        const id = getQueryParameters()["id"];
        const quoteid = getQueryParameters()["quoteid"];
        if (id) {
            NewBusinessAction.getInstruction(id);
        } else {
            this.setState({ isLoading: false });
        }

        if (!CommonHelper.isNullOrEmpty(hierarchyId)) {
            if (this.state.clientAccount) {
                this.updateClientAccountInfo(this.state.clientAccount);
            } else {
                Action.getClientAccount(hierarchyId, (val) => {
                    this.updateClientAccountInfo(val);
                });
            }
        }
        const quote = QuoteInstructionStore.getData();
        if (!quote && quoteid) {
            NewQuoteAction.getQuoteInstruction(quoteid);
        }
    }

    updateClientAccountInfo(val: ClientAccount): void {
        const { PensionApply } = this.state.data;
        PensionApply.ExistingPensionSubAccountHierarchyId = val?.SubAccounts?.find(
            (x) => x.SubAccountType == SubAccountType.Npr
        )?.HierarchyId;

        this.onChange({
            PensionApply: PensionApply,
            ExistingAccountHierarchyId: val?.HierarchyId,
            IsExistingAccount: true,
            AdviceGiven: true,
            AccountAdviceType: val?.Discretionary
                ? AccountAdviceType.Discretionary
                : AccountAdviceType.NonDiscretionary,
            IsJointAccount: val.InvestorType == InvestorType.Individual ? false : true,
            AccountName: { Full: val.AccountName },
            AccountServiceProposition: val?.AccountServicePropositionId,
            PaperLess: false,
            ExistingAccountPaperLess: val?.GoPaperless,
        });
        if (val != null) {this.setState({ clientAccount: val });}
    }

    saveInstruction(from, to, toUrl, params) {
        if (this.state.data?.AccountServiceProposition == ServiceProposition.Fundzone) {
            this.state.data.DisinvestmentStrategy = null;
        }
        this.state.data.CustomerId = parseInt(getQueryParameters()["customerid"]);
        NewBusinessAction.postInstruction(from, this.state.data, (result) => {
            if (result.length > 0) {
                this.setState({ errorMsg: result, isShowErrorMsg: true });
            } else {
                if (this.state.extraInfo.treasuredAssetsInstructionId) {
                    Action.setInstructionTreasuredAssetsProductIds(
                        this.state.extraInfo.treasuredAssetsInstructionId,
                        this.state.extraInfo.treasuredAssetProductIds,
                        () => {
                            this.setState({ onPosting: false });
                            this.navigate(to, toUrl, params);
                        }
                    );
                } else {
                    this.setState({ onPosting: false });
                    this.navigate(to, toUrl, params);
                }
            }
        });
    }

    private navigate(to, toUrl, params) {
        const customerId = params["customerid"];
        const quoteid = params["quoteid"];

        if (to == -1) {
            this.onExit();
        } else {
            Navigator.navigateTo(toUrl, {
                queryParamsObject: {
                    ...params,
                    customerid: customerId,
                    id: NewBusinessStore.getData()?.AccountRoleInstructionId,
                    quoteid: quoteid,
                },
                scrollAfterNavigating: true,
            });
        }
    }

    onExit() {
        const { data } = this.state;
        const customerId = getQueryParameters()["customerid"];
        const hierarchyid = getQueryParameters()["hierarchyid"];
        const id = HierarchyIdHelper.toHierarchyIdString(
            HierarchyLevelName.Customer,
            getQueryParameters()["customerid"]
        );
        if (data.AccountCreated) {
            PortfolioDashboardAction.setMultiSelection(
                id,
                PortfolioDashboardMultiSelectionStore.getData(),
                true,
                () => {
                    Navigator.navigateTo(
                        Urls.get().main.PortfolioDashboard({
                            hierarchyId: id,
                        }).summary
                    );
                }
            );
        } else if (!CommonHelper.isNullOrEmpty(hierarchyid)) {
            Navigator.navigateTo(
                Urls.get().main.PortfolioDashboard({
                    hierarchyId: id,
                }).summary
            );
        } else {
            Navigator.navigateTo(
                Urls.get().main.PortfolioDashboard({
                    hierarchyId: HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Customer, customerId),
                }).activity
            );
        }
    }

    onCancel() {
        // NewBusinessAction.cancleApplyInstruction(NewBusinessStore.getData()?.AccountRoleInstructionId, () =>
        //     this.onExit()
        // );
        //SLP-70599
        this.onExit();
    }

    onSubmit() {
        this.setState({ isSubmitting: true, active: false, isShowErrorMsg: false, errorMsg: [] });
        NewBusinessAction.submitInstruction(this.state.data, () => {
            this.setState({ isSubmitting: false });
        });
    }

    onSave(step) {
        if (step !== 0) {
            this.onStepperLeave(step, -1);
        } else {
            this.setState({ extraInfo: { isSaving: true, currentStep: step } });
        }
    }

    saveAndExit() {
        const step = this.state.extraInfo.currentStep;
        // Full client details
        if (step == 0) {
            if (this.stepValid(0)) {
                this.child[0].saveBeforeExit(true);
            } else {
                this.setState({ extraInfo: { isSaving: false, currentStep: step } });
            }
        }
        // wrapper selection
        else if (step == 1) {
            this.onExit();
        }
    }

    customeRender() {
        const { extraInfo } = this.state;
        return (
            <>
                {extraInfo.isSaving && (
                    <Lightbox
                        show={extraInfo.isSaving}
                        title={"Do you want to save and exit?"}
                        unclosable={true}
                        onClose={() => this.onChange({ extraInfo: { isSaving: false } })}
                        cssWrapper="is-default-lightbox is-narrow"
                        contentCssCustom="pt-20"
                    >
                        <p className="mb-10">
                            Only Customer details will be saved at this point, you will not be able to resume this
                            wizard.
                        </p>
                        <p>Are you sure you want to save and exit?</p>

                        <button className="btn primary mr-20 mt-20" onClick={() => this.saveAndExit()}>
                            Yes
                        </button>
                        <button
                            className="btn secondary  mt-20"
                            onClick={() => this.setState({ extraInfo: { isSaving: false } })}
                        >
                            No
                        </button>
                    </Lightbox>
                )}
            </>
        );
    }

    onTreasuredAssetsStoreChange() {
        const treasuredAssetProductIds = TreasuredAssetsStore.getTreasuredAssetsProductIds();
        this.setState({
            extraInfo: {
                treasuredAssetProductIds: treasuredAssetProductIds,
                treasuredAssetsInstructionId: null,
            },
        });
    }

    onChangeTreasuredAssets(hierarchyId: string, productId: number, value: boolean) {
        let productIds = this.state.extraInfo.treasuredAssetProductIds;
        if (value) {
            productIds.push(productId);
        } else {
            productIds = productIds.filter((id) => id !== productId);
        }
        this.setState({
            extraInfo: {
                treasuredAssetProductIds: productIds,
                treasuredAssetsInstructionId: HierarchyIdHelper.generateHierarchyId(hierarchyId).entityId,
            },
        });
    }

    getStepProps(index) {
        const { data } = this.state;
        const stepProps = super.getStepProps(index);
        return stepProps;
    }

    private getSIPPStepConfig(next: SubAccountType): IStepConfig[] {
        const { data } = this.state;
        let hasIST = 0;
        let hasDrawdown = 0;
        const sipp = data?.SelectedProducts.find((ele) => SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType));
        const len = this.stepperConfig.length;

        const restriction = RestrictionStore.getData();
        let transferinDisabled = false;
        let buyDisabled = false;
        if (restriction != null) {
            buyDisabled = RestrictionStore.buyDisabled();
            transferinDisabled = RestrictionStore.transferDisabled();
        }
        const steps: IStepConfig[] = [
            {
                title: NBSteppers.paymentsIn,
                url: Urls.get().NBPaymentsInSIPP,
                path: Contents.URLMap.paymentInSIPP,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: (
                    <PaymentsIn
                        {...this.getStepProps(len)}
                        transferDisabled={transferinDisabled}
                        processType={
                            CommonHelper.isNullOrEmpty(getQueryParameters()["hierarchyid"])
                                ? ProcessType.NB
                                : ProcessType.NBEC
                        }
                        HasExistingSIPP={this.state.clientAccount?.SubAccounts?.some((x) =>
                            SubAccountTypeHelper.isOnPlatformPension(x.SubAccountType)
                        )}
                    />
                ),
                group: NBSteppers.SIPP,
            },
            {
                title: NBSteppers.adviserCharges,
                url: Urls.get().NBAdviserChargesSIPP,
                path: Contents.URLMap.adviserChargesSIPP,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: <AdviserCharges {...this.getStepProps(len + 1)} />,
                group: NBSteppers.SIPP,
            },
        ];
        if (
            hasSinglePayments(data.PensionApply) ||
            hasRegularPayments(data.PensionApply) ||
            hasCashTransfer(data.PensionApply?.PensionTransfers)
        ) {
            hasIST = 1;
            steps.push({
                title: NBSteppers.investmentSelection,
                url: Urls.get().NBInvestmentSelectionSIPP,
                path: Contents.URLMap.investmentSelectionSIPP,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: (
                    <InvestmentSelectionTool
                        {...this.getStepProps(len + 2)}
                        treasuredAssetProductIds={this.state.extraInfo.treasuredAssetProductIds}
                        onTreasuredAssetsStoreChange={() => this.onTreasuredAssetsStoreChange()}
                        onChangeTreasuredAssets={(subAccountInstructionId, productId, value) => {
                            this.onChangeTreasuredAssets(subAccountInstructionId, productId, value);
                        }}
                    />
                ),
                group: NBSteppers.SIPP,
            });
        }
        if (sipp.PensionType !== PensionType.None) {
            hasDrawdown = 1;
            steps.push({
                title: NBSteppers.drawdownDetail,
                url: Urls.get().DrawdownNewbusiness,
                path: Contents.URLMap.drawdownDetailSipp,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: <DrawdownDetails {...this.getStepProps(len + 2 + hasIST)} />,
                group: NBSteppers.SIPP,
            });
        }
        if (showIncome(sipp, this.state.data?.PensionApply)) {
            steps.push({
                title: NBSteppers.incomePaymentDetails,
                url: Urls.get().NBIncomePaymentsSIPP,
                path: Contents.URLMap.incomePaymentsSIPP,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: (
                    <IncomePaymentDetails
                        {...this.getStepProps(len + 2 + hasIST + hasDrawdown)}
                        incomeOnly={sipp.PensionType === PensionType.None}
                    />
                ),
                group: NBSteppers.SIPP,
            });
        }
        if (next) {
            steps.push({
                title: "SIPP complete",
                url: Urls.get().NBSIPPComplete,
                path: Contents.URLMap.completeSIPP,
                component: <Transition from={SubAccountType.Npr} to={next} />,
                type: StepType.Extra,
            });
        }
        return steps;
    }

    private getPPStepConfig(next: SubAccountType): IStepConfig[] {
        const data = this.state.data;
        const len = this.stepperConfig.length;
        const pp = data?.SelectedProducts.find((item) => item.SubAccountType == SubAccountType.InvestmentAccount);
        const restriction = RestrictionStore.getData();
        let transferinDisabled = false;
        let buyDisabled = false;
        if (restriction != null) {
            buyDisabled = RestrictionStore.buyDisabled();
            transferinDisabled = RestrictionStore.transferDisabled();
        }
        const steps: IStepConfig[] = [
            {
                title: NBSteppers.paymentsIn,
                url: Urls.get().NBPaymentsInPP,
                path: Contents.URLMap.paymentInPP,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: (
                    <PaymentsInPP
                        {...this.getStepProps(len)}
                        transferDisabled={transferinDisabled}
                        processType={
                            CommonHelper.isNullOrEmpty(getQueryParameters()["hierarchyid"])
                                ? ProcessType.NB
                                : ProcessType.NBEC
                        }
                    />
                ),
                group: NBSteppers.PP,
            },
            {
                title: NBSteppers.adviserCharges,
                url: Urls.get().NBAdviserChargesPP,
                path: Contents.URLMap.adviserChargesPP,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: <AdviserChargesPP {...this.getStepProps(len + 1)} />,
                group: NBSteppers.PP,
            },
        ];
        let hasIST = false;
        if (hasSinglePayments(data.GiaModel) || hasRegularPayments(data.GiaModel)) {
            hasIST = true;
            steps.push({
                title: NBSteppers.investmentSelection,
                url: Urls.get().NBInvestmentSelectionPP,
                path: Contents.URLMap.investmentSelectionPP,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: (
                    <InvestmentSelectionToolPP
                        {...this.getStepProps(len + 2)}
                        treasuredAssetProductIds={this.state.extraInfo.treasuredAssetProductIds}
                        onTreasuredAssetsStoreChange={() => this.onTreasuredAssetsStoreChange()}
                        onChangeTreasuredAssets={(subAccountInstructionId, productId, value) => {
                            this.onChangeTreasuredAssets(subAccountInstructionId, productId, value);
                        }}
                    />
                ),
                group: NBSteppers.PP,
            });
        }
        if (
            pp?.IsAddRegularWithdrawalSelected &&
            (hasSinglePayments(data.GiaModel) ||
                hasRegularPayments(data.GiaModel) ||
                ChargesHelper.hasTransfers(data.GiaModel, SubAccountType.InvestmentAccount))
        ) {
            const gap = hasIST ? 3 : 2;
            steps.push({
                title: NBSteppers.withdrawal,
                url: Urls.get().NBWithdrawalsPP,
                path: Contents.URLMap.withdrawalsPP,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: (
                    <Withdrawals
                        {...this.getStepProps(len + gap)}
                        modelName="GiaModel"
                        type={ProcessType.NB}
                        onBankChange={(bank) => {
                            const banks = data.BankAccountInstructions
                                ? data.BankAccountInstructions.concat(bank)
                                : [bank];
                            this.onChange({ BankAccountInstructions: banks });
                        }}
                    />
                ),
                group: NBSteppers.PP,
            });
        }
        if (next) {
            steps.push({
                title: "Personal Portfolio complete",
                url: Urls.get().NBPPComplete,
                path: Contents.URLMap.completePP,
                component: <Transition from={SubAccountType.InvestmentAccount} to={next} />,
                type: StepType.Extra,
            });
        }

        return steps;
    }

    private getISAStepConfig(next: SubAccountType): IStepConfig[] {
        const data = this.state.data;
        const len = this.stepperConfig.length;
        const isa = this.state.data.SelectedProducts.find((ele) => ele.SubAccountType == SubAccountType.StocksIsa);
        const restriction = RestrictionStore.getData();
        let transferinDisabled = false;
        let buyDisabled = false;
        if (restriction != null) {
            buyDisabled = RestrictionStore.buyDisabled();
            transferinDisabled = RestrictionStore.transferDisabled();
        }
        const steps: IStepConfig[] = [
            {
                title: NBSteppers.paymentsIn,
                url: Urls.get().NBPaymentsInISA,
                path: Contents.URLMap.paymentInISA,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: (
                    <PaymentsInISA
                        {...this.getStepProps(len)}
                        processType={
                            CommonHelper.isNullOrEmpty(getQueryParameters()["hierarchyid"])
                                ? ProcessType.NB
                                : ProcessType.NBEC
                        }
                    />
                ),
                group: NBSteppers.ISA,
            },
            {
                title: NBSteppers.adviserCharges,
                url: Urls.get().NBAdviserChargesISA,
                path: Contents.URLMap.adviserChargesISA,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: <AdviserChargesISA {...this.getStepProps(len + 1)} />,
                group: NBSteppers.ISA,
            },
        ];
        let hasIST = false;
        if (
            hasSinglePayments(data.IsaModel) ||
            hasRegularPayments(data.IsaModel) ||
            hasCashTransfer(data.IsaModel?.IsaTransfers)
        ) {
            hasIST = true;
            steps.push({
                title: NBSteppers.investmentSelection,
                url: Urls.get().NBInvestmentSelectionISA,
                path: Contents.URLMap.investmentSelectionISA,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: (
                    <InvestmentSelectionToolISA
                        {...this.getStepProps(len + 2)}
                        treasuredAssetProductIds={this.state.extraInfo.treasuredAssetProductIds}
                        onTreasuredAssetsStoreChange={() => this.onTreasuredAssetsStoreChange()}
                        onChangeTreasuredAssets={(hierarchyId, productId, value) => {
                            this.onChangeTreasuredAssets(hierarchyId, productId, value);
                        }}
                    />
                ),
                group: NBSteppers.ISA,
            });
        }
        if (
            isa?.IsAddRegularWithdrawalSelected &&
            (hasSinglePayments(data.IsaModel) ||
                hasRegularPayments(data.IsaModel) ||
                ChargesHelper.hasTransfers(data.IsaModel, SubAccountType.StocksIsa))
        ) {
            const gap = hasIST ? 3 : 2;
            steps.push({
                title: NBSteppers.withdrawal,
                url: Urls.get().NBWithdrawalsISA,
                path: Contents.URLMap.withdrawalsISA,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: (
                    <Withdrawals
                        {...this.getStepProps(len + gap)}
                        modelName="IsaModel"
                        type={ProcessType.NB}
                        onBankChange={(bank) => {
                            const banks = data.BankAccountInstructions
                                ? data.BankAccountInstructions.concat(bank)
                                : [bank];
                            this.onChange({ BankAccountInstructions: banks });
                        }}
                    />
                ),
                group: NBSteppers.ISA,
            });
        }
        if (next) {
            steps.push({
                title: "ISA complete",
                url: Urls.get().NBISAComplete,
                path: Contents.URLMap.completeISA,
                component: <Transition from={SubAccountType.StocksIsa} to={next} />,
                type: StepType.Extra,
            });
        }
        return steps;
    }

    private getWrapCashStepConfig(): IStepConfig[] {
        return [
            {
                title: NBSteppers.paymentsIn,
                url: Urls.get().NBPaymentsInWrapCash,
                path: Contents.URLMap.paymentsInWrapCash,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: <WrapCashPaymentsIn {...this.getStepProps(this.stepperConfig.length)} />,
                group: NBSteppers.wrapCash,
            },
        ];
    }

    private getSippAndBondStepConfig(): IStepConfig[] {
        return [
            {
                title: NBSteppers.additionalProductDetails,
                url: Urls.get().NBPaymentsInLegacyProduct,
                path: Contents.URLMap.paymentsInLegacyProduct,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: (
                    <LegacyProductPaymentsIn
                        {...this.getStepProps(this.stepperConfig.length)}
                        processType={
                            CommonHelper.isNullOrEmpty(getQueryParameters()["hierarchyid"])
                                ? ProcessType.NB
                                : ProcessType.NBEC
                        }
                    />
                ),
            },
        ];
    }

    private getReviewStepConfig(): IStepConfig {
        return {
            title: NBSteppers.review,
            url: Urls.get().NewBusinessReview,
            path: Contents.URLMap.review,
            component: <Review {...this.getStepProps(this.stepperConfig.length)} />,
        };
    }

    private getDocAndDeclarationStepConfig(): IStepConfig {
        return {
            title: NBSteppers.doc,
            url: Urls.get().DocumentAndDeclarations,
            onStepLeave: (from, to) => this.onStepperLeave(from, to),
            onSubmit: this.needToOpenBondInOldWizard(this.state.data) ? null : () => this.onSubmit(),
            canSubmit: this.needToOpenBondInOldWizard(this.state.data)
                ? null
                : () => this.child[this.stepperConfig.length - 2].isValid(),
            path: Contents.URLMap.documentAndDeclarations,
            component: (
                <DocumentsAndDeclarations
                    {...this.getStepProps(this.stepperConfig.length)}
                    isReview={!this.state.active}
                    readonly={!this.state.active}
                    processType={
                        this.state.data?.IsNBEC
                            ? processTypeEnum.NewBusinessExistingClient
                            : processTypeEnum.NewBusiness
                    }
                    clAccountId={this.state.data?.ShellHeadClAccountId}
                    subAccountType={SubAccountType.NotSpecified}
                    isJointOrTrust={isJointOrTrustAccount(this.state.clientAccount?.InvestorType)}
                />
            ),
        };
    }

    needToOpenBondInOldWizard(data: ApplyModel): boolean {
        const legacyProductSelected = data.SelectedProducts.some((x) =>
            SubAccountTypeHelper.isLegacyProduct(x.SubAccountType)
        );
        const legacyProductSelectedOnly = data.SelectedProducts.every((x) =>
            SubAccountTypeHelper.isLegacyProduct(x.SubAccountType)
        );

        if (legacyProductSelectedOnly) {
            return true;
        }

        if (
            (data.AccountCreated ||
                !CommonHelper.isNullOrEmpty(data.ShellHeadClAccountId) ||
                !CommonHelper.isNullOrEmpty(getQueryParameters()["hierarchyid"])) &&
            legacyProductSelected
        ) {
            return true;
        }
        return false;
    }

    getOldNbecUrl(
        mapping: AccountRoleInstructionNbecWizardSessionMappingModel,
        clAccountId: string,
        bondOnly: boolean
    ): string {
        if (mapping == null || mapping.NbecWizardSessionId == 0) {
            return StaticUrls.NBEC(clAccountId, bondOnly, NewBusinessStore.getData()?.AccountRoleInstructionId ?? 0);
        } else if (mapping.NbecWizardSessionId > 0 && !bondOnly) {
            return StaticUrls.NBECSIPP(
                clAccountId,
                NewBusinessStore.getData()?.AccountRoleInstructionId ?? 0,
                mapping.NbecWizardSessionId
            );
        } else {
            return StaticUrls.NBECBond(
                clAccountId,
                NewBusinessStore.getData()?.AccountRoleInstructionId ?? 0,
                mapping.NbecWizardSessionId
            );
        }
    }

    private getTransitionalConfirmationStepConfig(lastProduct: SubAccountType) {
        const { data } = this.state;

        const to = data.SelectedProducts.some((x) => SubAccountTypeHelper.isOffPlatformPension(x.SubAccountType))
            ? SubAccountType.Sipp
            : data.SelectedProducts.some((x) => x.SubAccountType == SubAccountType.OnshoreBond)
            ? SubAccountType.OnshoreBond
            : SubAccountType.OffshoreBond;

        return {
            title: "",
            url: Urls.get().Confirmation,
            path: Contents.URLMap.confirmation,
            type: StepType.Confirmation,
            component: (
                <TransitionalConfirmation
                    onExit={() =>
                        (window.location.href = this.getOldNbecUrl(
                            (data as ApplyModel).AccountRoleInstructionNbecWizardSessionMapping,
                            (data as ApplyModel).ShellHeadClAccountId ||
                                ClientAccountStore.getClientAccountInfo()?.HeadClAccountId,
                            !(data as ApplyModel).SelectedProducts.some((x) => x.SubAccountType == SubAccountType.Sipp)
                        ))
                    }
                    from={lastProduct}
                    to={to}
                    buttonLabel={`Open ${subAccountTypeMap[to]}`}
                    isLoading={this.state.isSubmitting}
                    onPrevious={() => {
                        Navigator.navigateTo(Urls.get().DocumentAndDeclarations, {
                            queryParamsObject: getQueryParameters(),
                            scrollAfterNavigating: false,
                        });
                    }}
                />
            ),
        };
    }

    private getConfirmationStepConfig(): IStepConfig {
        const { data } = this.state;
        const id = HierarchyIdHelper.toHierarchyIdString(
            HierarchyLevelName.Customer,
            getQueryParameters()["customerid"]
        );
        return {
            title: NBSteppers.comfirmation,
            url: Urls.get().Confirmation,
            path: Contents.URLMap.confirmation,
            type: StepType.Confirmation,
            component: (
                <Confirmation
                    onExit={() => {
                        PortfolioDashboardAction.setMultiSelection(
                            id,
                            PortfolioDashboardMultiSelectionStore.getData(),
                            true,
                            () => {
                                Navigator.navigateTo(
                                    Urls.get().main.PortfolioDashboard({
                                        hierarchyId: id,
                                    }).summary
                                );
                            }
                        );
                    }}
                    buttonLabel={"Back to dashboard"}
                    successMessage={`We've successfully received your application for ${ClientNameHelper.clientNameDisplay(
                        data?.ClientDetails,
                        data?.SecondClientDetails
                    )} (${
                        CommonHelper.isNullOrEmpty(data.AccountCreated?.AccountId)
                            ? CommonHelper.isNullOrEmpty(data.ShellHeadClAccountId)
                                ? null
                                : data.ShellHeadClAccountId
                            : data.AccountCreated?.AccountId
                    })`}
                    isLoading={this.state.isSubmitting}
                />
            ),
        };
    }

    setStepperConfig() {
        const { data } = this.state;
        const needToOpenBondInOldWizard = this.needToOpenBondInOldWizard(data);
        const hasPension = this.state.data.SelectedProducts.some((ele) =>
            SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType)
        );
        const hasIsa = this.state.data.SelectedProducts.some((ele) => ele.SubAccountType == SubAccountType.StocksIsa);
        const hasPP = this.state.data.SelectedProducts.some(
            (ele) => ele.SubAccountType == SubAccountType.InvestmentAccount
        );
        const hasWrapCash = this.state.data.SelectedProducts.some(
            (ele) => ele.SubAccountType == SubAccountType.WrapCash
        );
        this.stepperConfig = [
            {
                title: NBSteppers.fullClientDetail,
                url: Urls.get().FullClientDetail,
                path: Contents.URLMap.fullClientDetail,
                type: StepType.Custom,
                component: (
                    <FullClientDetail
                        {...this.getStepProps(0)}
                        customerId={getQueryParameters()["customerid"]}
                        navigateAfterSubmit={true}
                        disableWhenFullClient={false}
                        // per latest br, client detail should be disabled in add new product wizard
                        isAddNewProduct={!CommonHelper.isNullOrEmpty(getQueryParameters()["hierarchyid"])}
                        clearMsg={() => this.setState({ errorMsg: [], isShowErrorMsg: false })}
                    />
                ),
            },
            {
                title: NBSteppers.wrapperSelection,
                url: Urls.get().WrapperSelection,
                path: Contents.URLMap.wrapperSelection,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                type: StepType.Standard,
                component: (
                    <WrapperSelection
                        {...this.getStepProps(1)}
                        HasExistingSIPP={this.state.clientAccount?.SubAccounts?.some((x) =>
                            SubAccountTypeHelper.isOnPlatformPension(x.SubAccountType)
                        )}
                        ClientAccount={this.state.clientAccount}
                    />
                ),
            },
        ];

        let lastProductType = SubAccountType.WrapCash;
        if (hasPension) {
            const next = hasIsa
                ? SubAccountType.StocksIsa
                : hasPP
                ? SubAccountType.InvestmentAccount
                : hasWrapCash
                ? SubAccountType.WrapCash
                : null;
            this.stepperConfig = this.stepperConfig.concat(this.getSIPPStepConfig(next));
            lastProductType = SubAccountType.Npr;
        }
        if (hasIsa) {
            const next = hasPP ? SubAccountType.InvestmentAccount : hasWrapCash ? SubAccountType.WrapCash : null;
            this.stepperConfig = this.stepperConfig.concat(this.getISAStepConfig(next));
            lastProductType = SubAccountType.StocksIsa;
        }
        if (hasPP) {
            const next = hasWrapCash ? SubAccountType.WrapCash : null;
            this.stepperConfig = this.stepperConfig.concat(this.getPPStepConfig(next));
            lastProductType = SubAccountType.InvestmentAccount;
        }
        if (hasWrapCash) {
            this.stepperConfig = this.stepperConfig.concat(this.getWrapCashStepConfig());
            lastProductType = SubAccountType.WrapCash;
        }

        if (this.state.data.SelectedProducts.some((ele) => SubAccountTypeHelper.isLegacyProduct(ele.SubAccountType))) {
            this.stepperConfig = this.stepperConfig.concat(this.getSippAndBondStepConfig());
            lastProductType = SubAccountType.WrapCash;
        }
        //this.stepperConfig.push(this.getDisinvestmentStrategyStepConfig());

        this.stepperConfig.push(this.getReviewStepConfig());
        this.stepperConfig.push(this.getDocAndDeclarationStepConfig());
        if (needToOpenBondInOldWizard) {
            this.stepperConfig.push(this.getTransitionalConfirmationStepConfig(lastProductType));
        } else {
            this.stepperConfig.push(this.getConfirmationStepConfig());
        }
    }

    getAccountHolderDisplayText() {
        const model: ApplyModel = this.state.data;
        if (Object.keys(this.child).length == 1) {
            //the child is the number of NB steps user has clicked through, when user lands on NB for the 1st time, he is on the 1st step, and the length of child will be 1.
            //The purpose is that if user is on the 1st step, full client detail, just display the 1st client name.
            return ClientNameHelper.clientNameDisplay(model?.ClientDetails, null);
        }
        // when user has step to the 2nd step, display the name of 1st client or both client base on user's selection.
        return ClientNameHelper.clientNameDisplay(
            model?.ClientDetails,
            model.IsJointAccount ? model?.SecondClientDetails : null
        );
    }

    setProcessProps() {
        const { data } = this.state;
        const processProps = super.setProcessProps();
        processProps.processTitle = CommonHelper.isNullOrEmpty(getQueryParameters()["hierarchyid"])
            ? "New business"
            : "Add new product";
        processProps.needSplitHeader = {
            fromStep: 0,
            splitHeaderMain: this.getAccountHolderDisplayText(),
            splitHeaderSub: `${
                data.AccountCreated
                    ? data.AccountCreated.AccountId
                    : CommonHelper.isNullOrEmpty(data?.ShellHeadClAccountId)
                    ? ""
                    : data?.ShellHeadClAccountId
            }`,
        };
        processProps.subTitle = Methods.getProductNameFromUrl();
        processProps.onSave = (step) => this.onSave(step);
        return processProps;
    }
}
